/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { findAllTeamMember_findAllTeamMember_items as TeamMember } from '__generatedTypes__/findAllTeamMember'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { getImageByDimensions } from 'utils/getImageByDimensions'
import { TableProps } from 'components/Table'
import * as classes from './TeamMembersList/styles'

const getTeamMemberColumns = (handleEditClick: (member: TeamMember) => void) => {
  const TeamMemberColumns: TableProps<TeamMember & { index: number }>['columns'] = [
    {
      title: <span css={classes.indexLabel}>#</span>,
      renderCell: (member) => (
        <Typography variant="body2" css={classes.index}>
          {member.index + 1}
        </Typography>
      ),
      flex: '0 1 30px',
    },
    {
      renderCell: (member) => (
        <div css={classes.avatar}>
          <img
            css={classes.avatar}
            src={getImageByDimensions(member.getAvatar.photo || '', 50, 50)}
            alt="Team member avatar"
            onError={(e) => {
              e.currentTarget.setAttribute('data-notfound', 'true')
            }}
          />
        </div>
      ),
      flex: '0 1 31px',
    },
    {
      title: 'Name',
      renderCell: (member) => (
        <Typography variant="body2" css={classes.longText}>
          {member.fullName}
        </Typography>
      ),
    },
    {
      title: 'Degree',
      renderCell: (member) => (
        <Typography css={classes.longText} variant="body2">
          {member.degree}
        </Typography>
      ),
    },
    {
      title: 'University',
      renderCell: (member) => (
        <Typography css={classes.longText} variant="body2">
          {member.university}
        </Typography>
      ),
    },
    {
      title: 'Position',
      renderCell: (member) => (
        <Typography css={classes.longText} variant="body2">
          {member.position}
        </Typography>
      ),
    },
    {
      renderCell: (member) => <EditIcon css={classes.editIcon} onClick={() => handleEditClick(member)} />,
      flex: '0 1 29px',
    },
  ]

  return TeamMemberColumns
}

export default getTeamMemberColumns
